import { Outlet, useLocation } from 'react-router-dom';

import { AssistantLauncher } from '../assistant/AssistantLauncher';
import { AssistantPanel } from '../assistant/AssistantPanel';
import { AssistantProvider } from '../assistant/AssistantContext';
import { WidgetErrorBoundary } from '../common/WidgetErrorBoundary';
import { ContextSidebar } from './ContextSidebar';
import { Header } from './Header';

export const AppShell = () => {
  // key по pathname: после ошибки рендера страница пробует отрисоваться
  // заново при переходе на другой маршрут.
  const { pathname } = useLocation();
  return (
    // AI-ассистент (US-10) живёт в shell, а не на странице: панель
    // открывается поверх любого экрана и не уводит с него (FR-1.1).
    <AssistantProvider>
      <div className="flex h-screen w-full flex-col overflow-hidden bg-surface-page">
        <Header />
        <div className="flex min-h-0 flex-1">
          <WidgetErrorBoundary>
            <ContextSidebar />
          </WidgetErrorBoundary>
          <main className="relative min-w-0 flex-1 overflow-y-auto">
            <WidgetErrorBoundary key={pathname}>
              <Outlet />
            </WidgetErrorBoundary>
          </main>
        </div>
      </div>
      {/* Упавший ассистент не должен ронять витрину — и не должен оставлять
          после себя текст «Данные недоступны» поверх страницы. */}
      <WidgetErrorBoundary fallback={<></>}>
        <AssistantLauncher />
        <AssistantPanel />
      </WidgetErrorBoundary>
    </AssistantProvider>
  );
};
